import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isInnerHTML", "description", "title", "prefixDataTestId", "showCloseButton", "wrapperStyles", "isClosed", "status", "variant", "svg", "onClick", "descriptionTextStyle", "descriptionStrongTextStyle", "sx"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, CloseButton, Flex, useMultiStyleConfig } from '@chakra-ui/react';
import { formatDataTestId, renderSanitizedHtml } from '@whitbread-eos/utils';
import { Dismiss } from '../../assets/icons';
import { semanticTextStyles } from '../../theme/adapters/semanticTypography';
import Icon from '../Icon';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export default function Notification(props) {
  var isInnerHTML = props.isInnerHTML,
    description = props.description,
    title = props.title,
    prefixDataTestId = props.prefixDataTestId,
    showCloseButton = props.showCloseButton,
    wrapperStyles = props.wrapperStyles,
    isClosed = props.isClosed,
    status = props.status,
    variant = props.variant,
    svg = props.svg,
    onClick = props.onClick,
    descriptionTextStyle = props.descriptionTextStyle,
    descriptionStrongTextStyle = props.descriptionStrongTextStyle,
    sx = props.sx,
    restProps = _objectWithoutProperties(props, _excluded);
  var styles = useMultiStyleConfig('Alert', {
    status,
    variant
  });
  var liveRegionRole = status === 'error' || status === 'warning' ? 'alert' : 'status';
  var containerStyles = _objectSpread(_objectSpread({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    overflow: 'hidden'
  }, styles.container), {}, {
    py: '1rem'
  }, wrapperStyles);
  var titleSemanticStyles = typeof restProps.textStyle === 'string' ? semanticTextStyles[restProps.textStyle] : {};
  var titleStyles = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, styles.title), titleSemanticStyles), {}, {
    maxWidth: 'full',
    mr: 0
  }, restProps.fontWeight ? {
    fontWeight: restProps.fontWeight
  } : {}), {}, {
    '& a:hover': {
      textDecoration: 'underline'
    }
  });
  var descriptionSemanticStyles = typeof descriptionTextStyle === 'string' ? semanticTextStyles[descriptionTextStyle] : {};
  var descriptionStrongSemanticStyles = typeof descriptionStrongTextStyle === 'string' ? semanticTextStyles[descriptionStrongTextStyle] : {};
  var descriptionStyles = _objectSpread(_objectSpread(_objectSpread({
    display: 'inline'
  }, styles.description), descriptionSemanticStyles), {}, {
    '& a:hover': {
      textDecoration: 'underline'
    },
    '& strong': _objectSpread({}, descriptionStrongSemanticStyles)
  });
  var closeIconStyle = {
    position: 'absolute',
    right: 'sm',
    top: 'sm'
  };
  var arrayDescription = Array.isArray(description);
  return _jsx(_Fragment, {
    children: !isClosed && (title || description) && _jsxs(Box, _objectSpread(_objectSpread({
      role: liveRegionRole,
      "aria-atomic": "true",
      p: "md"
    }, restProps), {}, {
      sx: _objectSpread(_objectSpread({}, containerStyles), sx),
      onClick: onClick,
      "data-testid": formatDataTestId(prefixDataTestId, 'Alert'),
      children: [_jsx(Icon, {
        style: {
          alignSelf: 'flex-start'
        },
        svg: svg
      }), _jsxs(Flex, {
        direction: "column",
        "data-testid": formatDataTestId(prefixDataTestId, 'AlertColumn'),
        children: [isInnerHTML && typeof title === 'string' ? _jsx(Box, {
          className: "formatLinks",
          sx: titleStyles,
          "data-testid": formatDataTestId(prefixDataTestId, 'AlertTitle'),
          children: renderSanitizedHtml(title)
        }) : _jsx(Box, {
          sx: titleStyles,
          "data-testid": formatDataTestId(prefixDataTestId, 'AlertTitle'),
          children: title
        }), isInnerHTML && typeof description === 'string' ? _jsx(Box, {
          className: "formatLinks",
          sx: descriptionStyles,
          "data-testid": formatDataTestId(prefixDataTestId, 'AlertDescription'),
          children: renderSanitizedHtml(description)
        }) : displayAlertDescriptionComponent()]
      }), onClick && showCloseButton && _jsx(CloseButton, _objectSpread(_objectSpread({}, closeIconStyle), {}, {
        children: _jsx(Icon, {
          svg: _jsx(Dismiss, {
            transform: "scale(1.1)"
          })
        })
      }))]
    }))
  });
  function displayAlertDescriptionComponent() {
    return arrayDescription ? description === null || description === void 0 ? void 0 : description.map((descriptionText, index) => {
      return _jsx(Box, {
        sx: descriptionStyles,
        "data-testid": formatDataTestId(prefixDataTestId, "AlertDescription-".concat(index)),
        children: descriptionText
      }, descriptionText);
    }) : _jsx(Box, {
      sx: descriptionStyles,
      "data-testid": formatDataTestId(prefixDataTestId, 'AlertDescription'),
      children: description
    });
  }
}